/**
 * RedirectToFirstAccessible Component
 * Redirects users to their first accessible page based on permissions
 */
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';

export const RedirectToFirstAccessible = () => {
  const { hasPermission, isSuperUser, getPermissions } = usePermissions();

  // SuperUsers always go to dashboard
  if (isSuperUser()) {
    return <Navigate to="/" replace />;
  }

  // Check if employee has NO permissions at all
  const permissions = getPermissions();
  if (permissions.length === 0) {
    return <Navigate to="/no-permissions" replace />;
  }

  // Find first accessible route based on permission priority
  if (hasPermission('view_dashboard')) {
    return <Navigate to="/" replace />;
  } else if (hasPermission('view_orders')) {
    return <Navigate to="/orders" replace />;
  } else if (hasPermission('view_payments')) {
    return <Navigate to="/payments" replace />;
  } else if (hasPermission('view_services')) {
    return <Navigate to="/services" replace />;
  } else if (hasPermission('view_patients')) {
    return <Navigate to="/users" replace />;
  } else if (hasPermission('view_specialists')) {
    return <Navigate to="/specialists" replace />;
  } else if (hasPermission('view_consultants')) {
    return <Navigate to="/consultants" replace />;
  } else if (hasPermission('view_ads')) {
    return <Navigate to="/ads" replace />;
  } else if (hasPermission('view_reports')) {
    return <Navigate to="/reports" replace />;
  } else if (hasPermission('view_settings')) {
    return <Navigate to="/settings" replace />;
  } else if (hasPermission('view_roles')) {
    return <Navigate to="/roles" replace />;
  } else if (hasPermission('view_employees')) {
    return <Navigate to="/employees" replace />;
  } else {
    // Has some permissions but none of the main view permissions - redirect to no permissions page
    return <Navigate to="/no-permissions" replace />;
  }
};

export default RedirectToFirstAccessible;

